
import React from 'react';
import { connect } from 'react-redux';

import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { DateTimeFormat } from '../date';


let ConfirmationWindow = ({translate, message, startDate, endDate, from, to, phoneNumber, }) => {
  return(
    <div className="modal fade bd-example-modal-lg" id="bd-example-modal-lg"  role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <div>
              <h5 className="modal-title" >{translate('confirmation-message-title')}</h5>
            </div>
          </div>
          <div className="modal-body ">
            <h6>{translate('confirmation-message')}</h6>
          </div>
          <div className="modal-body">
            <p>{`${message} `}</p>
          </div>

          {from ?
            <div className="modal-body">
             <p>{`${translate('from')} : ${from}`}</p>
            </div>
            :
             ''
          }
          {to ?
            <div className="modal-body">
             <p>{`${translate('to')} : ${to}`}</p>
            </div>
            :
             ''
          }
          {phoneNumber ?
            <div className="modal-body">
             <p>{`${translate('on-phone-number')} : ${phoneNumber}`}</p>
            </div>
            :
             ''
          }
          {startDate ?
            <div className="modal-body">
              {<p>{`${translate('start-date')} : ${startDate ? DateTimeFormat(startDate, 'DD/MM/YYYY HH:mm:ss') : translate('date-not-available')}`}</p>}
            </div>
            :
            ''
          }
          {endDate ?
            <div className="modal-body">
               {<p>{`${translate('end-date')} : ${endDate ? DateTimeFormat(endDate, 'DD/MM/YYYY HH:mm:ss') : translate('date-not-available')}`}</p>}
            </div>
            :
            ''
          }
          <div className="form-group row">
            <div className="col text-right">
              <button className="btn btn-secondary" type="button" data-target=".bd-example-modal-lg" data-toggle="modal" >{translate('cancel')}</button>
              <button className="btn btn-primary" type="submit" data-target=".bd-example-modal-lg" data-toggle="modal"  >{translate('confirm')}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const viewMapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {
  }
}

ConfirmationWindow = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(ConfirmationWindow);
export default ConfirmationWindow;



// WEBPACK FOOTER //
// ./src/lib/forms/ConfirmationWindow.js